import { Pipe, PipeTransform } from '@angular/core';
import { ErrorCodes } from '@cbre/http';

@Pipe({
  name: 'errorCodes',
  standalone: false,
})
export class ErrorCodesPipe implements PipeTransform {
  transform(
    errorMap: { [key in ErrorCodes]: string },
    codeKey: ErrorCodes,
    defaultTxt = 'An error has been encountered.'
  ): any {
    const message = codeKey != null ? errorMap && errorMap[codeKey] : defaultTxt;
    return message || defaultTxt;
  }
}
